import Reveal from "@/components/feature/Reveal";
import { INSTAGRAM_URL, COMPANY_NAME } from "@/constants";

export default function Instagram() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="site-container">
        <Reveal>
          <div className="grid items-center gap-6 rounded-lg bg-accent-500 p-6 md:grid-cols-[1fr_auto] md:p-9">
            <div className="flex items-center gap-4">
              <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-background-50/20">
                <i className="ri-instagram-line text-3xl text-background-50" />
              </span>
              <div>
                <p className="text-sm font-bold tracking-wide text-accent-50">
                  OFFICIAL INSTAGRAM
                </p>
                <p className="mt-1 font-heading text-xl font-black leading-snug text-background-50 md:text-2xl">
                  施工事例や会社の活動を発信しています
                </p>
                <p className="mt-2 max-w-xl text-sm leading-relaxed text-accent-50">
                  {COMPANY_NAME}の日々の施工の様子や片付けの事例などをInstagramでご紹介しています。「どんな会社か見てみたい」という方は、ぜひ覗いてみてください。
                </p>
              </div>
            </div>

            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-md bg-background-50 px-6 py-4 font-heading text-base font-black text-accent-700 transition-all hover:bg-accent-50"
            >
              <i className="ri-instagram-line text-xl" />
              <span className="whitespace-nowrap">Instagramを見る</span>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}